const updateItems = [
  {
    time: '10分钟前',
    title: '某知名导演新片阵容曝光，多位一线演员确认加盟',
    tag: '影视',
    tagColor: 'accent',
  },
  {
    time: '28分钟前',
    title: '热门综艺节目录制路透流出，嘉宾互动笑料不断',
    tag: '综艺',
    tagColor: 'primary',
  },
  {
    time: '1小时前',
    title: '当红歌手深夜发文疑似回应近期争议，粉丝纷纷力挺',
    tag: '音乐',
    tagColor: 'accent',
  },
  {
    time: '2小时前',
    title: '年度网络热词投票结果出炉，"吃瓜"稳居榜首',
    tag: '热点',
    tagColor: 'primary',
  },
  {
    time: '3小时前',
    title: '某品牌代言人官宣，引发网友热议和调侃',
    tag: '时尚',
    tagColor: 'accent',
  },
  {
    time: '4小时前',
    title: '热门电视剧续集剧本泄露？制片方紧急回应',
    tag: '影视',
    tagColor: 'primary',
  },
  {
    time: '5小时前',
    title: '选秀节目选手私下互动曝光，CP粉狂喜',
    tag: '选秀',
    tagColor: 'accent',
  },
  {
    time: '6小时前',
    title: '知名博主爆料娱乐圈潜规则，评论区炸锅',
    tag: '爆料',
    tagColor: 'primary',
  },
  {
    time: '8小时前',
    title: '某顶流偶像被拍到深夜与友人聚餐，状态轻松',
    tag: '明星',
    tagColor: 'accent',
  },
];

export default function UpdatesSection() {
  return (
    <section id="updates" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">
            实时快讯
          </h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-[500px] mx-auto">
            最新娱乐资讯即时推送，吃瓜不等待
          </p>
        </div>

        <div className="max-w-[900px] mx-auto">
          {updateItems.map((item, idx) => (
            <div
              key={idx}
              className="flex items-start gap-4 py-4 border-b border-background-200/60 last:border-0 cursor-pointer hover:bg-background-50/50 transition-colors px-3 rounded-lg"
            >
              <span className="text-xs text-foreground-400 whitespace-nowrap pt-0.5 w-[70px] flex-shrink-0">
                {item.time}
              </span>
              <span
                className={`flex-shrink-0 text-xs font-bold px-2 py-0.5 rounded whitespace-nowrap ${
                  item.tagColor === 'accent'
                    ? 'bg-accent-100 text-accent-600'
                    : 'bg-primary-100 text-primary-600'
                }`}
              >
                {item.tag}
              </span>
              <p className="text-sm md:text-base text-foreground-800 leading-relaxed">
                {item.title}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}